import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mixin from './mixin'
import './permission'
import 'lib-flexible' // 自适应兼容方案
import '@/assets/style/style.scss' //全局样式
import SvgIcon from 'vue-svgicon'
import '@/icons/components' //svg图标

Vue.config.productionTip = false

Vue.use(SvgIcon, {
  tagName: 'svg-icon'
})
Vue.mixin(mixin)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
